import { compose } from 'recompose';

import enhance from './SharedContainer';
import enhanceRefunds from './RefundsContainer';
import enhanceDiscounts from './DiscountsContainer';
import RefundsAndDiscounts from './RefundsAndDiscounts';

export const RefundsReport = compose(enhanceRefunds, enhance)(RefundsAndDiscounts);
export const DiscountsReport = compose(enhanceDiscounts, enhance)(RefundsAndDiscounts);
